import { sessionLoad } from 'Core/Utils/Session';

export default {
  loading: false,
  broken: false,
  savedTime: null,
  errorMessage: null,
  unsavedChanges: false,
  initialStateLoaded: false,
  sidebar: {
    pagesListCollapsed: sessionLoad('pagesListCollapsed'),
    blogsListCollapsed: sessionLoad('blogsListCollapsed'),
    assetsListCollapsed: sessionLoad('assetsListCollapsed')
  }
};



// WEBPACK FOOTER //
// ./client/RLX/State/Ui/UiInitialState.js